import { AgGridReact } from "ag-grid-react";
import { defaultColDef, getRowId, newsColumns } from "../../utils/gridHelper";
import { useCallback, useEffect, useMemo, useState } from "react";

import GridToolBar from "../GridToolBar";
import { deleteNews, getNews, getNewsTheme } from "../../utils/API/newsMethods";
import NewsForm from "../Form/NewsForm";
import { useStore } from "../../hooks/store";

export default function NewsGrid() {
  const store = useStore();
  const [gridData, setGridData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [quickFilterText, setQuickFilterText] = useState("");
  const [NewsData, setNewsData] = useState(undefined);

  const fetchNewsData = () => {
    getNews().then(({ data }) => {
      setGridData(data);
    });
  };

  const handleAddOpener = () => {
    getNewsTheme().then(({ data, rows }) => {
      store.setForm(<NewsForm categoryList={data || []} />, fetchNewsData);
    });
  };

  const handleRedactOpener = () => {
    getNewsTheme().then(({ data, rows }) => {
      store.setForm(
        <NewsForm categoryList={data || []} />,
        fetchNewsData,
        NewsData
      );
    });
  };

  const handleDelete = async () => {
    const { id } = NewsData;
    const deletedNews = await deleteNews(id);
    if (deletedNews.status !== 200) {
      store.setAlert(deletedNews.data, "error");
      return;
    }
    fetchNewsData();
  };

  const onGridReady = useCallback((e) => {
    // сохраняем АПИ
    setGridApi(e.api);
    fetchNewsData();
  }, []);

  //Отслеживаем изменение текста для фильтра, устанавливаем соответстствующий фильтр в грид
  useEffect(() => {
    gridApi?.setGridOption("quickFilterText", quickFilterText);
  }, [quickFilterText, gridApi]);

  //выбор конрентной строки
  const rowSelection = useMemo(() => {
    return {
      mode: "singleRow",
      checkboxes: true,
      enableClickSelection: true,
    };
  }, []);

  const rowClickHandler = (e) => {
    e.data && setNewsData(e.data);
  };

  return (
    <div style={{ maxWidth: "100%", height: "100%" }}>
      <GridToolBar
        filter={true}
        onAdd={handleAddOpener}
        onRefresh={fetchNewsData}
        onDelete={handleDelete}
        onUpdate={handleRedactOpener}
        filterValue={quickFilterText}
        filterOnChange={setQuickFilterText}
        dataToAction={NewsData}
      />
      <AgGridReact
        onGridReady={onGridReady}
        onRowClicked={rowClickHandler}
        gerRowId={getRowId}
        rowData={gridData}
        defaultColDef={defaultColDef}
        tooltipShowDelay={500}
        rowSelection={rowSelection}
        columnDefs={[...newsColumns]}
      />
    </div>
  );
}
